import { render, staticRenderFns } from "./MovePhotos.vue?vue&type=template&id=4a1879e6"
import script from "./MovePhotos.vue?vue&type=script&lang=js"
export * from "./MovePhotos.vue?vue&type=script&lang=js"
import style0 from "./MovePhotos.vue?vue&type=style&index=0&id=4a1879e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports